import React from "react"
import PropTypes from "prop-types"
import { Box, LinearProgress, Typography } from "@mui/material"
import theme from "src/v2/theme/theme"

const CadastroLoteProgressBar = ({ value = 0 }) => {
    const isCompleted = value >= 100

    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                minWidth: 120,
            }}
        >
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    height: 22,
                    borderRadius: 2,
                    backgroundColor: theme.palette.input.background.secondary,

                    "& .MuiLinearProgress-bar": {
                        borderRadius: 2,
                        backgroundColor: isCompleted
                            ? theme.palette.success.main
                            : theme.palette.warning.main,
                    },
                }}
            />

            <Typography
                sx={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: theme.palette.primary.contrastText,
                    fontSize: 12,
                    fontWeight: 700,
                }}
            >
                {value} %
            </Typography>
        </Box>
    )
}

CadastroLoteProgressBar.propTypes = {
    value: PropTypes.number,
}

export default CadastroLoteProgressBar